import { Badge } from "@/components/ui";
import type { AccionObservacion, EstadoRevisionDocumento } from "../services/revision-documental.api";

const ESTILO: Record<EstadoRevisionDocumento, { color: string; label: string }> = {
  NoRequiere: { color: "slate", label: "Sin revisión" },
  PendienteDeRevision: { color: "info", label: "Por revisar" },
  Aprobado: { color: "exito", label: "Aprobado" },
  Observado: { color: "advertencia", label: "Observado" },
};

/**
 * Estado de revisión de un documento (Gestión Documental · fase 3). Sin estado (null) no se
 * pinta nada: el documento aún no se envió a autorización. Un observado indica además si
 * devuelve la solicitud o la bloquea.
 */
export function EstadoRevisionBadge({
  estado,
  accion,
}: {
  estado: EstadoRevisionDocumento | null;
  accion?: AccionObservacion | null;
}) {
  if (!estado) return null;
  const { color, label } = ESTILO[estado];
  const detalle = estado === "Observado" && accion === "Bloquear" ? " · bloquea" : "";
  return (
    <Badge size="xs" color={estado === "Observado" && accion === "Bloquear" ? "peligro" : color}>
      {label}
      {detalle}
    </Badge>
  );
}
